function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
import React from "react";
import classNames from "classnames";
import { CSSTransition } from "react-transition-group";
import { injectIntl } from "react-intl";
import { isEqual } from "lodash";
// displays a small alert box in the player that goes away automatically after a given timeout
// Note: this is different from the NotificationDialog, which is used for longer messages
var AlertsApp = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    _inherits(AlertsApp, _React_Component);
    var _super = _createSuper(AlertsApp);
    function AlertsApp(props) {
        _classCallCheck(this, AlertsApp);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            hidden: !!props.currentAlert
        };
        _this._onNewAlert = _this._onNewAlert.bind(_assertThisInitialized(_this));
        _this.handleOnDismiss = _this.handleOnDismiss.bind(_assertThisInitialized(_this));
        _this.dismissAlertTimeout = null;
        return _this;
    }
    var _proto = AlertsApp.prototype;
    _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
        var _this_props = this.props, currentAlert = _this_props.currentAlert, dismissAlert = _this_props.dismissAlert;
        if (!isEqual(prevProps.currentAlert, currentAlert)) {
            if (!prevProps.currentAlert && currentAlert) {
                this._onNewAlert();
            }
            if (currentAlert) {
                if (!this.state.hidden) {
                    if (this.dismissAlertTimeout) {
                        clearTimeout(this.dismissAlertTimeout);
                        this.dismissAlertTimeout = null;
                    }
                    // hide alert component after alert timeout or 6 sec if not specified
                    this.dismissAlertTimeout = setTimeout(function() {
                        dismissAlert();
                    }, currentAlert.timeout || 6000);
                }
            }
        }
    };
    _proto.render = function render() {
        var currentAlert = this.props.currentAlert;
        var classes = classNames("notification", {
            "notification--info": !!currentAlert && currentAlert.type === "info",
            "notification--warning": !!currentAlert && currentAlert.type === "warning",
            "notification--danger": !!currentAlert && currentAlert.type === "danger",
            "notification--success": !!currentAlert && currentAlert.type === "success"
        });
        var msg = currentAlert ? /^[a-z_\-0-9]+\.[a-z_\-0-9].*/.test(currentAlert.message) ? this.props.intl.formatMessage({
            id: currentAlert.message,
            defaultMessage: ""
        }) : currentAlert.message : "";
        return currentAlert ? /*#__PURE__*/ React.createElement(CSSTransition, {
            in: Boolean(currentAlert),
            timeout: 300,
            classNames: "notification-dialog"
        }, /*#__PURE__*/ React.createElement("div", {
            className: classes,
            role: "status"
        }, /*#__PURE__*/ React.createElement("div", {
            dangerouslySetInnerHTML: {
                __html: msg
            }
        }))) : null;
    };
    _proto._onNewAlert = function _onNewAlert() {
        this.setState({
            hidden: false
        });
    };
    _proto.handleOnDismiss = function handleOnDismiss(evnt) {
        evnt.preventDefault();
        this.setState({
            hidden: true
        });
    };
    return AlertsApp;
}(React.Component);
export default injectIntl(AlertsApp);
